// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8834fe40","732":"cfc75318","977":"dfdbbab9"}[chunkId] + ".chunk.js";
};